import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class RelationshipDto  {
    _originalTypeClassName = "zSHR.BO.RelationshipDto";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
RelationshipDto.translate = translateService;
}
this.Value = null;
this.Display = null;
this.RelationshipDtoKey = null;
this._key = this.RelationshipDtoKey = 0; 
}

static translate: TranslateService;
_key: any;
Value:any;
Display:any;
private _RelationshipDtoKey:any;
get RelationshipDtoKey(): any {
    return this._RelationshipDtoKey;
  }
set RelationshipDtoKey(value: any) {
    this._RelationshipDtoKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.RelationshipDtoKey == null || $this.RelationshipDtoKey == 0;
            }


}